import axiosInstance from "./axios";

export const fetchProjects = (page = 1, filters = {}, search = "") => {
  const params = new URLSearchParams({ page });

  if (filters.status) params.append("status", filters.status);
  if (filters.customer_id) params.append("customer_id", filters.customer_id);
  if (filters.zone_id) params.append("zone_id", filters.zone_id);
  if (filters.city_id) params.append("city_id", filters.city_id);
  if (filters.service_status)
    params.append("service_status", filters.service_status);
  if (filters.per_page) params.append("per_page", filters.per_page);
  if (search) params.append("search", search);

  return axiosInstance.get(`/projects?${params.toString()}`);
};

// Page adapter for AsyncAutocomplete: (page, search) => { items, hasMore }
export const fetchProjectPage = async (page, search, filters = {}) => {
  const res = await fetchProjects(page, filters, search || "");
  const paginator = res.data ?? {};
  return {
    items: Array.isArray(paginator.data) ? paginator.data : [],
    hasMore: (paginator.current_page ?? page) < (paginator.last_page ?? 1),
  };
};

export const exportProjects = (filters = {}, search = "") => {
  const params = new URLSearchParams();

  if (filters.status) params.append("status", filters.status);
  if (filters.customer_id) params.append("customer_id", filters.customer_id);
  if (filters.zone_id) params.append("zone_id", filters.zone_id);
  if (filters.city_id) params.append("city_id", filters.city_id);
  if (filters.service_status)
    params.append("service_status", filters.service_status);
  if (search) params.append("search", search);
  params.append("export", "1");

  return axiosInstance.get(`/projects?${params.toString()}`, {
    responseType: 'blob'
  });
};

export const fetchProjectCounts = (filters = {}, search = "") => {
  const params = new URLSearchParams();
  if (filters.zone_id) params.append("zone_id", filters.zone_id);
  if (filters.city_id) params.append("city_id", filters.city_id);
  if (search) params.append("search", search);
  return axiosInstance.get(`/projects/counts?${params.toString()}`);
};

export const fetchProjectById = (id) => {
  return axiosInstance.get(`/projects/${id}`);
};

export const createProject = (projectData) => {
  return axiosInstance.post("/projects", projectData);
};

export const updateProject = (id, projectData) => {
  return axiosInstance.put(`/projects/${id}`, projectData);
};

export const deleteProject = (id) => {
  return axiosInstance.delete(`/projects/${id}`);
};

export const createProjectFromLead = (leadId, payload) => {
  return axiosInstance.post(`/leads/${leadId}/create-project`, payload);
};
